import React from 'react';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import Block from 'components/structure/Block/Block';
import Section from 'components/structure/Section';

function SectionLastMessage() {
  return (
    <Section
      backgroundColor="white"
      contained
      minHeight="auto"
    >
      <Block
        backgroundColor="primary"
        blockWidth="100%"
        alignItems="center"
        textAlign="center"
      >
        <Typography
          variant="paragraph2"
          color="white"
          colorVariant="default"
          intlKey="LENDING.LAST_MESSAGE.TITLE"
        />
        <Typography
          variant="paragraph2"
          tag="p"
          color="white"
          colorVariant="default"
          intlKey="LENDING.LAST_MESSAGE.DESCRIPTION"
        />
      </Block>
    </Section>
  );
}

export default React.memo(SectionLastMessage);
